import React, { useEffect, useState } from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { useAuth } from '../context/AuthContext';
import AuthNavigator from './AuthNavigator';
import UserNavigator from './UserNavigator';
import AdminNavigator from './AdminNavigator';
import { LoadingIndicator } from '../components';
import { navigationRef, saveCurrentRoute, loadSavedRoute } from './NavigationUtils';
import { Platform } from 'react-native';

const AppNavigator = () => {
  const { isAuthenticated, loading, isAdmin } = useAuth();
  const [initialState, setInitialState] = useState(undefined);

  // Sayfa yüklendiğinde kaydedilen navigasyon durumunu yükle (web için)
  useEffect(() => {
    if (Platform.OS === 'web') {
      const savedState = loadSavedRoute();
      if (savedState) {
        setInitialState(savedState);
      }
    }
  }, []);

  // Navigasyon değiştiğinde, yeni durumu kaydet (web için)
  const handleStateChange = (state) => {
    if (Platform.OS === 'web' && state) {
      saveCurrentRoute();
    }
  };

  if (loading) {
    return <LoadingIndicator />;
  }

  return (
    <NavigationContainer 
      ref={navigationRef}
      initialState={initialState}
      onStateChange={handleStateChange}
      linking={{
        prefixes: [],
        config: {
          screens: {
            Home: 'home',
            Children: 'children',
            Activities: {
              path: 'activities',
              screens: {
                ActivitiesList: 'list',
                ParkHistory: 'history',
                ActiveParkActivities: 'active',
                PendingActivities: 'pending',
              }
            },
            Menu: 'menu',
            Profile: 'profile'
          }
        }
      }}
    >
      {isAuthenticated ? (
        isAdmin ? <AdminNavigator /> : <UserNavigator />
      ) : (
        <AuthNavigator />
      )}
    </NavigationContainer>
  );
};

export default AppNavigator;
